import EventBus from '@/services/event-bus';
import Api from '@/services/Api';

function findOptionById(options, id) {
  if (!Array.isArray(options)) return null;
  return options.find((option) => String(option.id) === String(id));
}

export default {
  namespaced: true,
  state: {
    selectedStatuses: [],
    requestFromDate: null,
    requestToDate: null,
    tipoEnvio: [],
    materialStates: [],
    materialDeliveryTypes: [],
    materialOptionsLoaded: false,
    materialOptionsLoading: false,
  },
  actions: {
    async fetchMaterialFilterOptions({ commit, state }) {
      if (state.materialOptionsLoaded || state.materialOptionsLoading) {
        return Promise.resolve();
      }

      commit('setMaterialOptionsLoading', true);

      try {
        const xhr = await Api.get_material_states();
        const response = JSON.parse(xhr.response);

        commit('setMaterialStates', response.material_states || []);
        commit(
          'setMaterialDeliveryTypes',
          response.materials_delivery || []
        );
        commit('setMaterialOptionsLoaded', true);
        return Promise.resolve();
      } catch (error) {
        commit('setMaterialStates', []);
        commit('setMaterialDeliveryTypes', []);
        commit('setMaterialOptionsLoaded', true);
        return Promise.resolve();
      } finally {
        commit('setMaterialOptionsLoading', false);
      }
    },
    setSelectedStatuses({ commit }, value) {
      commit('setSelectedStatuses', value);
    },
    setTipoEnvio({ commit }, value) {
      commit('setTipoEnvio', value);
    },
    setRequestFromDate({ commit }, value) {
      commit('setRequestFromDate', value);
    },
    setRequestToDate({ commit }, value) {
      commit('setRequestToDate', value);
    },
    clearFilters({ commit }) {
      commit('clearFilters');
    },
    callMaterialWithFilters({ state }) {
      const selectedStatus = Array.isArray(
        state.selectedStatuses
      )
        ? state.selectedStatuses[0] ?? null
        : state.selectedStatuses ?? null;
      const selectedTipoEnvio = Array.isArray(state.tipoEnvio)
        ? state.tipoEnvio[0] ?? null
        : state.tipoEnvio ?? null;
      EventBus.$emit('MaterialRequest', [
        findOptionById(state.materialStates, selectedStatus) ||
          selectedStatus,
        selectedTipoEnvio,
        state.requestFromDate,
        state.requestToDate,
      ]);
    },
    // Backward compatibility with older dispatch name.
    callMaterialdWithFilters({ dispatch }) {
      dispatch('callMaterialWithFilters');
    },
    // callSamplesTypeForFilters({ state }) {
    //   EventBus.$emit('materialRequest');
    // },
  },
  mutations: {
    setSelectedStatuses(state, value) {
      state.selectedStatuses = value;
    },
    setTipoEnvio(state, value) {
      state.tipoEnvio = value;
    },
    setMaterialStates(state, value) {
      state.materialStates = value;
    },
    setMaterialDeliveryTypes(state, value) {
      state.materialDeliveryTypes = value;
    },
    setMaterialOptionsLoaded(state, value) {
      state.materialOptionsLoaded = value;
    },
    setMaterialOptionsLoading(state, value) {
      state.materialOptionsLoading = value;
    },
    setRequestFromDate(state, value) {
      state.requestFromDate = value;
    },
    setRequestToDate(state, value) {
      state.requestToDate = value;
    },
    clearFilters(state) {
      state.selectedStatuses = [];
      state.tipoEnvio = [];
      state.requestFromDate = null;
      state.requestToDate = null;
    },
  },
};
